import React, { useEffect, useState } from "react";
import { showError } from "../../utils/toastUtils";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import userAPI from "../../api/UserApi";
import { FiArrowRight, FiPackage } from "react-icons/fi";

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = async () => {
    try {
      const res = await userAPI.fetchMyOrders();
      if (res.code === 200) {
        setOrders(res.data);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="account-orders-funky mb-5">
        {orders && orders.length > 0 ? (
          <div className="account-orders-wrap">
            {/* Component Badge Title */}
            <div className="orders-dashboard-header mb-4">
              <span className="badge-text-purple">ORDER HISTORY ({orders.length})</span>
            </div>

            <div className="table-responsive funky-orders-table-wrapper">
              <table className="funky-orders-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th className="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                    <tr key={order._id || index} className="funky-order-row">
                      <td>
                        <Link
                          to={`/users/order-details/${order.orderId}`}
                          className="order-id-link"
                        >
                          #{order.orderId}
                        </Link>
                      </td>
                      <td className="order-date-text">
                        {getDateAgo(order?.orderDate)}
                      </td>
                      <td className="order-price-bold">
                        ₹{order.total}
                      </td>
                      <td>
                        <span className={`status-badge-funky status-${order?.status?.toLowerCase() || "pending"}`}>
                          {order.status.toUpperCase()}
                        </span>
                      </td>
                      <td className="text-end">
                        <Link
                          to={`/users/order-details/${order.orderId}`}
                          className="view-detail-btn-funky"
                        >
                          Detail <FiArrowRight className="ms-1" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          /* EMPTY STATE FLOW */
          <div className="account-no-orders-funky text-center py-5">
            <div className="empty-orders-icon-box mb-4">
              <FiPackage size={50} />
            </div>
            <h3 className="empty-title mb-2">YOU HAVEN'T PLACED ANY ORDERS YET</h3>
            <p className="empty-subtitle mb-4">It’s time to fill your bag with premium premium snacks and ornaments! ⚡</p>
            <Link to="/shop" className="shop-now-funky-btn">
              START SHOPPING 
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default Orders;